import React, { useState, useEffect } from "react";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import { useLocation,Link } from "react-router-dom";
import "../Assets/Css/CourseList.css";
import tempChapter from "../Assets/Json/tempChapter.json";
import Select from "react-select";
import { COURSE_VIDEOS_LIST } from "./AllApi";


const CourseList = () => {
  const location = useLocation();
  // console.log(" : ", tempChapter[0]);
  // const [syllabus, setSyllabus] = useState(tempChapter);
  const [isLoading, setIsLoading] = useState(false);
  const [allData, setAllData] = useState([]); 
  const [filteredData, setFilteredData] = useState([]);

  const grades = [
    // { value: "5", label: "Grade 5" },
    { value: "6", label: "Grade 6" },
    { value: "7", label: "Grade 7" },
    { value: "8", label: "Grade 8" },
    { value: "9", label: "Grade 9" },
    // Add more grades
  ];
    // Check if grade is passed via location.state
    const initialGrade = location.state?.selectedGrade || { value: "6", label: "Grade 6" };
    const [selectedGrade, setSelectedGrade] = useState(initialGrade);
  const [searchInput, setSearchInput] = useState("");


  useEffect(() => {
    setIsLoading(true);
    const token = localStorage.getItem("authToken");
    fetch(COURSE_VIDEOS_LIST, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.videoAssessment?.length > 0) {
          setAllData(data.videoAssessment); 
          console.log("course: ",data)
          // Save all grades data
          // Initially show data for grade 5
          // setFilteredData(
          //   data.videoAssessment.find(
          //     (gradeData) => gradeData.vid_grade === 5
          //   )?.chapters || []
          // );
          // setAllData(data.videoAssessment);
          // Filter data for the initial grade
          const gradeData = data.videoAssessment.find(
            (grade) => grade.vid_grade === parseInt(initialGrade.value)
          );
          setFilteredData(gradeData?.chapters || []);
        } else {
          setAllData([]);
          setFilteredData([]);
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [initialGrade.value]);

 
 
  useEffect(() => {
    const lowercaseSearchInput = searchInput.toLowerCase();
    
    // Filter the chapters for the selected grade
    // const gradeData = allData.find(
    //   (gradeData) => gradeData.vid_grade === parseInt(selectedGrade.value)
    // );

    let gradeData = allData.find(
      (gradeData) => gradeData?.vid_grade === parseInt(selectedGrade.value)
    );
  
    // Fallback if no data for the selected grade
    if (!gradeData) {
      gradeData = allData[0]; // Use the first available grade
      setSelectedGrade({ value: gradeData?.vid_grade.toString(), label: `Grade ${gradeData?.vid_grade}` });
    }
    
    const filtered = gradeData ? gradeData.chapters.filter((chapter) => {
      const matchesSearch =
        searchInput === "" ||
        (chapter.chapter_no &&
          chapter.chapter_no.toString().includes(lowercaseSearchInput)) ||
        (chapter.chapter_name &&
          chapter.chapter_name.toLowerCase().includes(lowercaseSearchInput));

      return matchesSearch;
    }) : [];

    setFilteredData(filtered);
  }, [selectedGrade, searchInput, allData]);

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            {/*  */}
            <div className="row me-4 mt-4">
              {/* <div className="col-lg-9 col-12">
                <p className="admin_title">Chapters</p>
              </div> */}
              <div className="col-lg-6 col-12">
                <p className="admin_title">Chapters</p>
              </div>
              <div className="col-lg-3 col-6 mt-4">
                <Select
                  options={grades}
                  value={selectedGrade}
                  onChange={(option) => setSelectedGrade(option)}
                  placeholder="Filter by Grade"
                />
              </div>
              <div className="col-lg-3 col-12 mt-4">
                <input
                  type="search"
                  className="form-control search-input"
                  placeholder="Search"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                />
              </div>
            </div>

            {isLoading ? (
              <div>
                <Loader />
              </div>
            ) : (
              <>
                {/* syllabus */}
                {filteredData?.length <= 0 && (
                  <div className="text-center noDataContainer">
                    <div className="noData">No data available</div>
                  </div>
                )}
                {filteredData?.length > 0 && (
                  <div className="row row-col-auto">
                    {filteredData?.map((data, ind) => {
                      return (
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 col-12"
                          key={ind}
                        >
                          <div className="mb-5 me-2">
                            <Link
                              to="/courses/videosList"
                              style={{
                                color: "black",
                                textDecoration: "none",
                              }}
                              state={{
                                videos: data.videos,
                                chapter_id: data.chapter_id,
                                chapter_name: data.chapter_name,
                                chapter_desc:data.chapter_description,
                                grade:selectedGrade,
                              }}
                            >
                              <>
                                {data?.chapter_thumbnail === "" ||
                                data?.chapter_thumbnail === null ? (
                                  <div className="blur_img">
                                    <img
                                      src=""
                                      alt="courses_img"
                                      className="Syllabus_Images"
                                      style={{ borderRadius: "16px",height:"203px"  }}
                                    />
                                  </div>
                                ) : (
                                  <div className="blur_img">
                                    <img
                                      src={data?.chapter_thumbnail}
                                      alt="courses_img"
                                      className="Syllabus_Images"
                                      style={{ borderRadius: "16px",height:"203px"  }}
                                    />
                                  </div>
                                )}

                                <div className="chapter_desc">
                                  <p className="chapter_number">{`Chapter ${data.chapter_no}`}</p>
                                  <p className="chapter_title">
                                    {data.chapter_name}
                                  </p>
                                </div>
                              </>
                            </Link>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {filteredData?.length === 0 && searchInput !== "" && (
                  <div className="noDataContainer">
                    <div className="text-center noData">No data available</div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CourseList;
